// extracted by mini-css-extract-plugin
module.exports = {"customError":"CustomError_customError__o6Ond"};